
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n238Child = []
  var n239Child = []
  n239Child = n239Child.concat(text(t('.longitude')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n239 = h('label', props, n239Child)
  n238Child.push(n239)
  var n240Child = []
  var n241Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "longitude"},{name:'value', val: shadow.longitude},{name:'type', val: "number"},{name:'step', val: "0.000000001"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n241 = h('input', props, n241Child)
  n240Child.push(n241)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n240 = h('div', props, n240Child)
  n238Child.push(n240)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n238 = h('div', props, n238Child)
  n0Child.push(n238)
  var n242Child = []
  var n243Child = []
  n243Child = n243Child.concat(text(t('.latitude')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n243 = h('label', props, n243Child)
  n242Child.push(n243)
  var n244Child = []
  var n245Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "latitude"},{name:'value', val: shadow.latitude},{name:'type', val: "number"},{name:'step', val: "0.000000001"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n245 = h('input', props, n245Child)
  n244Child.push(n245)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n244 = h('div', props, n244Child)
  n242Child.push(n244)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n242 = h('div', props, n242Child)
  n0Child.push(n242)
  var n246Child = []
  var n247Child = []
  n247Child = n247Child.concat(text(t('.distance')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n247 = h('label', props, n247Child)
  n246Child.push(n247)
  var n248Child = []
  var n249Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "distance"},{name:'value', val: shadow.distance},{name:'type', val: "number"},{name:'step', val: "0.01"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n249 = h('input', props, n249Child)
  n248Child.push(n249)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n248 = h('div', props, n248Child)
  n246Child.push(n248)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n246 = h('div', props, n246Child)
  n0Child.push(n246)
  var n250Child = []
  var n251Child = []
  n251Child = n251Child.concat(text(t('.operator')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n251 = h('label', props, n251Child)
  n250Child.push(n251)
  var n252Child = []
  var n253Child = []
  var n254Child = []
  n254Child = n254Child.concat(text(t('.less_than')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "<"},{name:'selected', val: (shadow.operator == "<")}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n254 = h('option', props, n254Child)
  n253Child.push(n254)
  var n255Child = []
  n255Child = n255Child.concat(text(t('.greater_than')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: ">"},{name:'selected', val: (shadow.operator == ">")}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n255 = h('option', props, n255Child)
  n253Child.push(n255)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "operator"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n253 = h('select', props, n253Child)
  n252Child.push(n253)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n252 = h('div', props, n252Child)
  n250Child.push(n252)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n250 = h('div', props, n250Child)
  n0Child.push(n250)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  